export default {
    szpRed: '#dc1d2b',
    sz_red: '#ED1C24',
    sz_violet: '#6C83FF',
    sz_blue: '#324EE6',
    sz_grafit: '#414345',
    sz_dark_grey: '#66686A',
    sz_medium_grey: '#9DA0A1',
    sz_grey: '#BEC0C2',
    sz_light_grey: '#DCE2E7',
    sz_background_light: '#F7F8FB',
    sz_green: '#00BB62'
};
